import React from "react";
import { Collapse, IconButton, Typography } from "@material-ui/core";
import ExploreIcon from '@material-ui/icons/Explore';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import TrainingList from "./TrainingList";
import { TrainingHeader } from "../../store/trainings/models";

interface TrainingCityGroupProps {
    city: string;
    trainings: TrainingHeader[];
}

const TrainingCityGroup: React.FC<TrainingCityGroupProps> = ({ city, trainings }) => {

    const [isOpen, open] = React.useState<boolean>();

    const season = trainings[0].year;

    React.useEffect(() => {

        try {
            const state = window.localStorage.getItem(`trainings--${season}---${city}`);
            if (state === 'open') {
                open(true);
                return;
            }

            if (window.location.hash.includes(`hint=${encodeURI(city)}`)) {
                open(true);
            }


        } catch (e) {
            console.error(e);
        }


    }, [city, season]);

    const setOpen = React.useCallback((o: boolean) => {

        open(o);

        try {

            if (!!o) {
                window.localStorage.setItem(`trainings--${season}---${city}`, 'open');
            } else {
                window.localStorage.setItem(`trainings--${season}---${city}`, 'closed');
            }

        } catch (e) {
            console.error(e);
        }

    }, [city, season]);

    return <div key={city} style={{ marginBottom: '16px' }}><Typography color={"primary"} variant="h5" style={{ marginBottom: '8px' }} key={city}><ExploreIcon fontSize={"small"} />  {city}  <IconButton onClick={() => setOpen(!isOpen)}>{isOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}</IconButton> </Typography><Collapse in={isOpen}><TrainingList trainings={trainings}></TrainingList></Collapse></div>
};

export default TrainingCityGroup;